import { render, staticRenderFns } from "./SignInWithAppleButton.vue?vue&type=template&id=584f7c08"
import script from "./SignInWithAppleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInWithAppleButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SignInWithAppleButton.vue?vue&type=style&index=0&id=584f7c08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports